import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function HoraDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [hora, setHora] = useState(null);
  const [empleados, setEmpleados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [editando, setEditando] = useState(false);
  const [form, setForm] = useState({});
  const [error, setError] = useState('');

  useEffect(() => { cargar(); }, [id]);

  const cargar = async () => {
    try {
      const [hRes, eRes] = await Promise.all([
        API.get(`/horas/${id}`),
        API.get('/empleados'),
      ]);
      setHora(hRes.data);
      setEmpleados(eRes.data);
      setForm({
        horas: hRes.data.horas,
        fecha: hRes.data.fecha?.split('T')[0] || '',
        notas: hRes.data.notas || '',
        empleado_id: hRes.data.empleado_id || '',
      });
    } catch(e) {}
    setCargando(false);
  };

  const guardar = async () => {
    try {
      await API.put(`/horas/${id}`, {
        horas: parseFloat(form.horas),
        fecha: form.fecha + 'T00:00:00',
        notas: form.notas || null,
        empleado_id: form.empleado_id ? parseInt(form.empleado_id) : null,
      });
      setEditando(false);
      cargar();
    } catch(e) { setError('Error al guardar'); }
  };

  const eliminar = async () => {
    if (!window.confirm('¿Eliminar esta imputación?')) return;
    await API.delete(`/horas/${id}`);
    navigate('/horas');
  };

  const fmtFecha = (iso) => iso ? new Date(iso).toLocaleDateString('es-ES', {day:'2-digit',month:'2-digit',year:'numeric'}) : '—';

  if (cargando) return <div style={s.loading}>Cargando...</div>;
  if (!hora) return <div style={s.loading}>Imputación no encontrada</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <button style={s.backBtn} onClick={() => navigate(-1)}>← Volver</button>
      </div>

      <div style={s.content}>
        <div style={s.header}>
          <div>
            <div style={s.headerTitulo}>Imputación de horas</div>
            <div style={s.headerSub}>{hora.proyecto_nombre}</div>
          </div>
          {usuario?.rol === 'admin' && !editando && (
            <div style={s.headerActions}>
              <button style={s.btnDanger} onClick={eliminar}>Eliminar</button>
              <button style={s.btn} onClick={() => setEditando(true)}>Editar</button>
            </div>
          )}
        </div>

        {!editando ? (
          <div style={s.card}>
            <div style={s.cardTitle}>Detalle</div>
            <div style={s.infoRow}><span style={s.infoLabel}>Empleado</span><span>{hora.empleado_nombre}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Proyecto</span><span>{hora.proyecto_nombre}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Fecha</span><span>{fmtFecha(hora.fecha)}</span></div>
            <div style={s.infoRow}><span style={s.infoLabel}>Horas</span><span style={{fontWeight:600,color:'#378ADD'}}>{hora.horas}h</span></div>
            {hora.tarea_nombre && <div style={s.infoRow}><span style={s.infoLabel}>Tarea</span><span>{hora.tarea_nombre}</span></div>}
            {hora.notas && <div style={s.infoRow}><span style={s.infoLabel}>Notas</span><span>{hora.notas}</span></div>}
          </div>
        ) : (
          <div style={s.card}>
            <div style={s.cardTitle}>Editar imputación</div>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}>
              <label style={s.label}>Empleado</label>
              <select style={s.input} value={form.empleado_id} onChange={e => setForm({...form, empleado_id: e.target.value})}>
                <option value="">Sin asignar</option>
                {empleados.map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
              </select>
            </div>
            <div style={s.fieldRow}>
              <div style={{...s.field,flex:1}}>
                <label style={s.label}>Fecha</label>
                <input style={s.input} type="date" value={form.fecha} onChange={e => setForm({...form, fecha: e.target.value})} />
              </div>
              <div style={{...s.field,flex:1}}>
                <label style={s.label}>Horas</label>
                <input style={s.input} type="number" step="0.5" value={form.horas} onChange={e => setForm({...form, horas: e.target.value})} />
              </div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Notas</label>
              <input style={s.input} value={form.notas} onChange={e => setForm({...form, notas: e.target.value})} />
            </div>
            <div style={s.footer}>
              <button style={s.btnSecondary} onClick={() => setEditando(false)}>Cancelar</button>
              <button style={s.btn} onClick={guardar}>Guardar cambios</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#aaa', fontSize:14 },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center' },
  backBtn: { background:'none', border:'none', fontSize:13, color:'#378ADD', cursor:'pointer', fontWeight:500 },
  content: { padding:24, display:'flex', flexDirection:'column', gap:16, maxWidth:600 },
  header: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:24, display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:16 },
  headerTitulo: { fontSize:18, fontWeight:600, color:'#1a1a1a', marginBottom:4 },
  headerSub: { fontSize:13, color:'#888' },
  headerActions: { display:'flex', gap:8 },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, padding:20 },
  cardTitle: { fontSize:13, fontWeight:600, color:'#1a1a1a', marginBottom:16 },
  infoRow: { display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'0.5px solid #f0f0ed', fontSize:13 },
  infoLabel: { color:'#888' },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  btnDanger: { background:'#FCEBEB', color:'#A32D2D', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  footer: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:16 },
};
